const DEFAULT_ICP_URL = 'https://beian.miit.gov.cn/';

type SiteMetadataEnvKey =
  | 'VITE_PUBLIC_APP_URL'
  | 'VITE_SITE_ICP_NUMBER'
  | 'VITE_SITE_ICP_URL'
  | 'VITE_SITE_NAME';

function readEnv(name: SiteMetadataEnvKey): string {
  let value: string | undefined;
  switch (name) {
    case 'VITE_PUBLIC_APP_URL':
      value = import.meta.env.VITE_PUBLIC_APP_URL;
      break;
    case 'VITE_SITE_ICP_NUMBER':
      value = import.meta.env.VITE_SITE_ICP_NUMBER;
      break;
    case 'VITE_SITE_ICP_URL':
      value = import.meta.env.VITE_SITE_ICP_URL;
      break;
    case 'VITE_SITE_NAME':
      value = import.meta.env.VITE_SITE_NAME;
      break;
  }
  return typeof value === 'string' ? value.trim() : '';
}

export const siteMetadata = {
  name: readEnv('VITE_SITE_NAME') || 'Personal Blog',
  publicUrl: readEnv('VITE_PUBLIC_APP_URL'),
  icpNumber: readEnv('VITE_SITE_ICP_NUMBER'),
  icpUrl: readEnv('VITE_SITE_ICP_URL') || DEFAULT_ICP_URL,
} as const;

export function hasIcpMetadata(): boolean {
  return siteMetadata.icpNumber.length > 0;
}
